//Validation functions

import { GAME_CONFIG } from './gameConfig';

//Macro bool
export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}


//Password
export const validatePassword = (password: string): ValidationResult => {
  const errors: string[] = [];
  const { PASSWORD_MIN_LENGTH, PASSWORD_REQUIREMENTS } = GAME_CONFIG;

  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push(`Password must be at least ${PASSWORD_MIN_LENGTH} characters long`);
  }

  if (PASSWORD_REQUIREMENTS.requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }

  if (PASSWORD_REQUIREMENTS.requireLowercase && !/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }

  if (PASSWORD_REQUIREMENTS.requireNumbers && !/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }

  if (PASSWORD_REQUIREMENTS.requireSpecialChars && !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};


//Username
export const validateUsername = (username: string): ValidationResult => {
  const errors: string[] = [];

  if (!username.trim()) {
    errors.push('Username is required');
  }

  if (username.length < 3) {
    errors.push('Username must be at least 3 characters long');
  }

  if (username.length > 20) {
    errors.push('Username must be no more than 20 characters long');
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
    errors.push('Username can only contain letters, numbers, hyphens, and underscores');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};


//Email
export const validateEmail = (email: string): ValidationResult => {
  const errors: string[] = [];

  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.push('Please enter a valid email address');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};


//Name
export const validateName = (name: string, fieldName: string): ValidationResult => {
  const errors: string[] = [];

  if (!name.trim()) {
    errors.push(`${fieldName} is required`);
  }

  if (name.length > 50) {
    errors.push(`${fieldName} must be no more than 50 characters long`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};


//Initials
export const validateInitials = (initials: string): ValidationResult => {
  const errors: string[] = [];

  if (!initials.trim()) {
    errors.push('Initials are required');
  }

  //ToDo: Fix this if it ever becomes an issue
  if (initials.length < 2 || initials.length > 4) {
    errors.push('Initials must be 2-4 characters long');
  }

  if (!/^[A-Za-z]+$/.test(initials)) {
    errors.push('Initials can only contain letters');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};


//Class code
export const validateClassCode = (classCode: string): ValidationResult => {
  const errors: string[] = [];

  if (!classCode.trim()) {
    errors.push('Class code is required');
  }

  if (classCode.length < 8) {
    errors.push('Class code must be at least 8 characters long');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
